export default [
    {
        // [0]
        key: "codigo_empleado",
        label: "Codigo",
        sortable: true,
        visible: true,
    },
    {
        // [0]
        key: "full_name",
        label: app.$i18n.t("Employee"),
        sortable: true,
        visible: true,
        stickyColumn: true,
        isRowHeader: true,
    },
    {
        // [0]
        key: "fecha_cese",
        label: "Info Cese",
        sortable: false,
        visible: true,
    },
    {
        // [0]
        key: "document_number",
        label: app.$i18n.t("Document Number"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        // [0]
        key: "personal_type",
        label: app.$i18n.t("Personal Type"),
        sortable: false,
        visible: true,
    },
    {
        // [0]
        key: "area",
        label: app.$i18n.t("Area"),
        sortable: true,
        visible: false,
    },
    // {
    //     // [0]
    //     key: "labor_regime",
    //     label: app.$i18n.t("Regime"),
    //     thClass:"text-center",
    //     tdClass:"text-center",
    //     sortable: true,
    //     visible: true,
    // },
    {
        // [0]
        key: "type_form",
        label: app.$i18n.t("Contract"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    // {
    //     // [0]
    //     key: "mandatory_contribution",
    //     label:'% ' +app.$i18n.t("Contribution"),
    //     thClass: "text-center",
    //     tdClass: "text-center",
    //     sortable: true,
    //     visible: true,
    // },
    {
        // [0]
        key: "payment_method",
        label: app.$i18n.t("Payment Method"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        key: "tiene_otro_pago",
        label: "PAGO ADICIONAL",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [0]
        key: "salary_per_month",
        label: app.$i18n.t("Salary"),
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [0]
        key: "bonification",
        label: app.$i18n.t("Bonification"),
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [0]
        key: "salary_per_day",
        label: app.$i18n.t("Salary Per Day"),
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [6]
        key: "worked_days",
        label: app.$i18n.t("Assisted"), tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [6]
        key: "not_worked_days",
        label: app.$i18n.t("Not Assisted"), tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [2]
        key: "pension_fund",
        label: "Sistema de pensiones",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [2]
        key: "tipo_comision",
        label: "TIPO COMISION",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "porcentaje_contribucion",
        label: "% Contribución",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "monto_contribucion",
        label: "DSC. Contribución",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "porcentaje_seguro",
        label: "% Seguro",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "monto_seguro",
        label: "DSC. Seguro",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "porcentaje_comision",
        label: "% Comisión",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "monto_comision",
        label: "DSC. Comisión",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "total_aportaciones",
        label: "DSC. Tot. Aportaciones",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "descuento_x_falta",
        label: "DSC. Faltas",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "other_discounts",
        label: "DSC. Otros",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "monto_quinta",
        label: "DSC. RET. Quinta",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "total_discount",
        label: "Descuentos",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "bono_quincena",
        label: "Bono Quincena",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "fortnight_amount",
        label: app.$i18n.t("Fortnight"),
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "bono_mensual",
        label: "Bono Fin de mes",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [4]
        key: "monthly_amount",
        label: app.$i18n.t("Amount"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        key: "or_salary",
        label: "SALARIO Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_bonification",
        label: "SALARIO Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_salary_per_day",
        label: "Salario Diario Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_descuento_x_falta",
        label: "DSC. FALTA ADICIONAL",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_others_discount",
        label: "DSC. OTROS ADICIONAL",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_total_descuento",
        label: "DESCUENTOS ADICIONAL",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_bono_quincena",
        label: "Bono Quincena Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_fortnight_amount",
        label: "Quincena Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_bono_mensual",
        label: "Bono Fin de Mes Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_total_amount",
        label: "SUELDO Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        // [4]
        key: "payroll_status",
        label: app.$i18n.t("Status"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
        sortable: true,
    },
    // {
    //     // [4]
    //     key: "is_ready_approve",
    //     label: app.$i18n.t("Payroll"),
    //     thClass: "text-center",
    //     tdClass: "text-center",
    //     visible: true,
    // },
    {
        // [13]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]